// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.8724 14.494L16.3928 17.0021L23.5021 17.0021V19.0021L16.3928 19.0021L18.8724 21.5102L17.4501 22.9163L12.5918 18.0021L17.4501 13.0879L18.8724 14.494Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8762 14C12.0139 15.103 11.5 16.4915 11.5 18C11.5 19.5085 12.0139 20.897 12.8762 22H2V20C2 16.6863 4.68629 14 8 14H12.8762Z"}}]};

const UserArrowLeftFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-arrow-left-filled',
    ref,
    icon: element,
  },
));

UserArrowLeftFilledIcon.displayName = 'UserArrowLeftFilledIcon';

export default UserArrowLeftFilledIcon;
